export default __webpack_public_path__ + "static/media/collection-ico.9b2b7019.svg";